export default __webpack_public_path__ + "content/media/14.48772cd1.jpg";